import classNames from 'classnames'

import * as PopulusIcons from '../../../assets/icons'
import { OnClickEvent, PopulusColor } from '../sharedTypes'

import './index.scss'

interface IconProps {
  backgroundColor?: PopulusColor
  backgroundHoverColor?: PopulusColor
  borderColor?: PopulusColor
  className?: string
  color?: PopulusColor
  // 'span' when the icon sits inside a <button> or other phrasing-content-only
  // element, where a div root is invalid HTML. Styling is identical (class-based).
  component?: 'div' | 'span'
  disabled?: boolean
  hoverColor?: PopulusColor
  icon: IconName
  onClick?: OnClickEvent
  small?: boolean
}

export type IconName = keyof typeof PopulusIcons

export const Icon = ({
  backgroundColor,
  backgroundHoverColor,
  borderColor,
  className,
  color,
  component: Component = 'div',
  disabled,
  hoverColor,
  icon,
  onClick,
  small,
}: IconProps) => {
  const IconImage = PopulusIcons[icon]
  const rootProps = {
    className: classNames(
      'populus-icon',
      backgroundColor && `background-${backgroundColor}`,
      backgroundHoverColor && `background-hover-${backgroundHoverColor}`,
      borderColor && `border-${borderColor}`,
      disabled && 'disabled',
      small && 'small',
      className
    ),
    onClick: !disabled && onClick ? onClick : undefined,
  }
  return (
    <Component {...rootProps}>
      {IconImage && (
        <IconImage
          className={classNames(
            `populus-icon-svg-${color}`,
            hoverColor && `populus-icon-svg-hover-${hoverColor}`
          )}
        />
      )}
    </Component>
  )
}
